export const ONBOARDING_CALENDLY_URL = "https://calendly.com/d/3q8-sk8-8ft/roboflow-onboarding";

export function trackOnboardingCalendlyOpened(source: string) {
    window.eventTracker.event({ type: "Onboarding Call Opened", data: { source } });
}

export function openOnboardingCalendly(source: string) {
    trackOnboardingCalendlyOpened(source);

    const calendlyUrl = new URL(ONBOARDING_CALENDLY_URL);
    calendlyUrl.searchParams.set("utm_source", "app");
    calendlyUrl.searchParams.set("utm_campaign", source);

    window.open(calendlyUrl.toString(), "_blank");
}
